import React from 'react'
import {
    BlockWrapper,
    ChildrenBlock,
    defineBlock,
    smartProps,
    useInspectorControl,
} from '@smartfire/js-block-engine'
import clsx from 'clsx'
import style from './block.module.scss'

const InspectorLazy = React.lazy(() => import('./Inspector'))

type TwoEncartsProps = {
    hasBackground: boolean
}

const TwoEncarts: React.FC<TwoEncartsProps> = ({ hasBackground }) => {
    useInspectorControl(InspectorLazy, [])

    return (
        <BlockWrapper.Div className={clsx(style.block, hasBackground && style.background)}>
            <ChildrenBlock
                gutenbergEditorConfig={{
                    allowedBlocks: ['smartfire/two-encarts---encart'],
                    template: [
                        ['smartfire/two-encarts---encart'],
                        ['smartfire/two-encarts---encart'],
                    ],
                    templateLock: 'insert',
                }}
                className={clsx(style.children, 'content-width')}
            />
        </BlockWrapper.Div>
    )
}

export default defineBlock({
    Block: TwoEncarts,
    smartProps: {
        hasBackground: smartProps.bool.withDefault(true),
    },
    setup: {
        title: '2 Encarts',
    },
})
